var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.ready
    ? _c("div")
    : _vm.arg.Type == "monthRangeOrQuarter"
    ? _c("app-arg-input-month-range-or-quarter-select", {
        attrs: { label: _vm.label, value: _vm.value, arg: _vm.arg },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "monthOrQuarter"
    ? _c("app-arg-input-month-or-quarter-select", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "monthOrQuarterOrDate"
    ? _c("app-arg-input-month-or-quarter-or-date-select", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "dateRange"
    ? _c("app-arg-input-date-range", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "ledgerRange"
    ? _c("app-arg-input-ledger-range", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "productSku"
    ? _c("app-arg-input-product-sku", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "productSkuList"
    ? _c("app-arg-input-product-sku-list", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "stockLocationsList"
    ? _c("app-arg-input-stock-location-list", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "journal"
    ? _c("app-arg-input-journal", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "saleIdList"
    ? _c("app-arg-input-sale-list", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "clientIdList"
    ? _c("app-arg-input-contact-list", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 1 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "supplierIdList"
    ? _c("app-arg-input-contact-list", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 2 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "prospectIdList"
    ? _c("app-arg-input-contact-list", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 3 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "clientId"
    ? _c("app-arg-input-contact", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 1 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "supplierId"
    ? _c("app-arg-input-contact", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 2 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "prospectId"
    ? _c("app-arg-input-contact", {
        attrs: { label: _vm.label, value: _vm.value, "group-id": 3 },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.arg.Type == "bankType"
    ? _c("app-arg-input-bank-type", {
        attrs: { label: _vm.label, value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _vm.arg.Type == "number"
                ? _c("w-input-number", {
                    attrs: {
                      value: _vm.value,
                      fancy: "",
                      label: _vm.label,
                      decimals: _vm.arg.Decimals,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  })
                : _vm.arg.Type === "date"
                ? _c("w-date-picker", {
                    attrs: { value: _vm.value, fancy: "", label: _vm.label },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  })
                : _vm.arg.Type == "bookyear"
                ? _c("app-book-year-select", {
                    attrs: { fancy: "", value: _vm.value, label: _vm.label },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  })
                : _vm.arg.Type == "priceCategory"
                ? _c("app-sell-price-category-select", {
                    attrs: {
                      label: _vm.label,
                      fancy: "",
                      value: _vm.value,
                      "use-number": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput(_vm.value)
                      },
                    },
                  })
                : _vm.arg.Type == "bool"
                ? _c("w-checkbox", {
                    attrs: { label: _vm.label, value: _vm.value == "true" },
                    on: {
                      input: function ($event) {
                        return _vm.onInput(`${$event}`)
                      },
                    },
                  })
                : _vm.arg.Type == "select"
                ? _c("w-select", {
                    attrs: {
                      label: _vm.label,
                      value: _vm.value,
                      items: _vm.selectOptions,
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  })
                : _c("w-input", {
                    attrs: { value: _vm.value, fancy: "", label: _vm.label },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }